module.exports = __webpack_public_path__ + "img/tu03.3bc0b657.jpg";